<script>
	import Home from "./pages/Home.svelte";
	import Router from 'svelte-spa-router';
	import Modal from "svelte-simple-modal";
	// import {MUMBAI_TESTNET_CHAIN_ID, MUMBAI_TESTNET_HEX_CHAIN_ID} from "./constants/constants";
	// import ChainModal from "./components/chain-modal/ChainModal.svelte";

	const routes = {
		"/": Home,
		"/*": Home
	};
	// <!--let isCorrectChain = (window.ethereum.chainId === MUMBAI_TESTNET_HEX_CHAIN_ID) ? true : false;-->
	// <!--window.ethereum.on('networkChanged', (networkId) => {-->
	// <!--	if (networkId != MUMBAI_TESTNET_CHAIN_ID) {-->
	// <!--		$: isCorrectChain = false;-->
	// <!--	} else {-->
	// <!--		$: isCorrectChain = true;-->
	// <!--	}-->
	// })
</script>
<!--<div id="wrapper" class={`${isCorrectChain?"":"disabled"}`}>-->
<div id="wrapper">
	<Modal closeOnOuterClick={false}>
<main id="main">
	<!--{#if !isCorrectChain}-->
	<!--	<ChainModal/>-->
	<!--{/if}-->
	<Router {routes}/>
</main>
	</Modal>
</div>
